const joinedValuesSeparator = ', ';
const dateTimeFormatWithSeconds = 'YYYY-MM-DD HH:mm:ss';
const dateTimeFormat = 'DD-MM-YY HH:mm';
const dateFormat = 'YYYY-MM-DD';
const defaultPerPageCount: number = 20;
const paginationOptions: number[] = [
    20,
    60,
    100,
    0,
];

export {
    joinedValuesSeparator,
    dateTimeFormatWithSeconds,
    dateTimeFormat,
    dateFormat,
    defaultPerPageCount,
    paginationOptions,
};
